export interface InsuranceProvider {
  uid: string;
  name: string;
  description: string;
  data: Record<string, unknown>;
}

export interface MedicalPlan {
  id: string;
  title: string;
  description: string;
  content: string;
  price: string;
  period: string;
  image: string;
}

export interface InsurancePlan {
  id: number;
  idCard?: IdCardType
  uid: string;
  providerId: number;
  status: number;
  name: string;
  category: string;
  type: string;
  productFamily: string;
  metalTier: string;
  averagePrice: number;
  shortDescription: string;
  marketingName: string;
  networkName: string | null;
  marketSegment: string;
  priority: number;
  effectiveDate: string | null;
  terminationDate: string | null;
  eligGroup: string | string[];
  eligWaitingPeriod: string;
  eligEmployeeType: string;
  eligEnrollmentWindow: string | null;
  eligAgeLimit: number | null;
  eligDependentAgeLimit: number | null;
  prices: Array<{
    id?: number;
    tier: string | null;
    price: number;
    coverage: number;
    data?: {
      coverageAmount: number;
      dependentCount: number;
      minAge: number;
      maxAge: number;
      rate: number;
    };
  }>;
  documents: Array<{
    displayName: string;
    fileName: string;
    path: string;
    type?: string;
  }>;
  tags: string[];
  longDescription?: string;
  details?: Record<string, unknown>;
}

export enum IdCardType {
  None = 0,
  ClaimForm = 1,
  CignaMedical = 2,
  GuardianVision = 3,
  EquitableDental = 4,
}